
export default class MemberConfirmBankAccountRequestModel {
    public bankAccountId: number = 0;
    public confirmed: boolean = false;
}
